export default {"src":"/_next/static/media/kz.7c2ea99d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};